import * as React from "react";
import { SVGProps } from "react";

const Whitecoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="\u56FE\u5C42_1"
    x={0}
    y={0}
    viewBox="0 0 42 42"
    {...props}
  >
    <style>{".st0{fill:#40506b}"}</style>
    <path
      d="M28.8 17.7v2.6H36c-.1-.7-.1-1.9-.4-2.6h-6.8zM36 22h-8.5v2.6h8.1c.3-.8.3-1.9.4-2.6zM5.8 24.5h8.1v-2.6H5.4c.1.8.1 1.9.4 2.6zm0-6.8c-.1.7-.3 1.8-.4 2.6h7.2v-2.6H5.8z"
      className="st0"
    />
    <path
      d="M20.6 20.7c-.4 1.5-.9 3-1.3 4.5s-.9 3-1.4 4.5h-3.5c-.4-.9-.8-1.8-1.2-3-.4-1.1-.9-2.4-1.3-3.8-.4-1.3-.9-2.8-1.4-4.4s-.9-3-1.3-4.7h4.7c.1.7.4 1.5.5 2.3.2.9.4 1.7.6 2.6l.6 2.7c.2.9.5 1.8.7 2.6.3-.9.5-1.8.8-2.7.3-.9.5-1.8.7-2.7.2-.9.4-1.8.6-2.6.2-.9.4-1.6.6-2.3h3.3c.1.7.4 1.5.6 2.3.2.9.4 1.7.6 2.6s.4 1.8.7 2.7c.2.9.5 1.8.8 2.7.2-.9.5-1.7.7-2.6s.5-1.8.7-2.7c.2-.9.4-1.8.6-2.6.2-.9.4-1.6.5-2.3h4.7c-.4 1.6-.9 3.1-1.3 4.7-.5 1.6-.9 3-1.4 4.4-.4 1.3-.9 2.6-1.3 3.8-.4 1.1-.8 2.2-1.2 3h-3.5L22 25.2c-.5-1.5-.9-2.9-1.4-4.5z"
      className="st0"
    />
    <path
      d="M21 42C9.4 42 0 32.6 0 21S9.4 0 21 0s21 9.4 21 21-9.4 21-21 21zm0-39C11.1 3 3 11.1 3 21s8.1 18 18 18 18-8.1 18-18S30.9 3 21 3z"
      className="st0"
    />
  </svg>
);

export default Whitecoin;
